import { render, staticRenderFns } from "./NotificationEditor.vue?vue&type=template&id=a3451b74"
import script from "./NotificationEditor.vue?vue&type=script&lang=ts"
export * from "./NotificationEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports